import { Breadcrumb, Col, Row, Typography } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import InactiveUsers from "../../../components/Tables/InactiveUsers";
import { translate } from "../../../locale";

const { Title } = Typography;

const UsersInactives = () => {
  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="12">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {translate("Pacientes inactivos")}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Pacientes inactivos")}
          </Title>
        </Col>

        <Col span="24" className="mt-6">
          <InactiveUsers selectedData={{ period: 30, subscription: 1 }} />
        </Col>
      </Row>
    </div>
  );
};

export default UsersInactives;
